import useBenzinNetworksContext from './useBenzinNetworksContext'

export default useBenzinNetworksContext
